var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gutenberg"},_vm._l((_vm.data),function(block,index){return _c(_vm.components.get(_vm.parseBlockName(block.blockName)),{key:index,tag:"component",attrs:{"data":block.blockName.includes('acf/') ? block.attrs.data : block}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }